export default "__VITE_ASSET__ac38ad9e__"